import React from 'react';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';
import { Tooltip } from "components";

export const debitNoteColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_debitNoteId,
    getColumns_comId,
    getColumns_accountCode,
    getColumns_productCode, 
    getColumns_SqlAccountInvoiceNo,
    getColumns_productName,
    getColumns_dealerCode,
    getColumns_salesPersonCode,
    getColumns_debitNoteRemark,
    getColumns_chargeMethod,
    getColumns_quantity,
    getColumns_unitPrice,
    getColumns_subtotal,
    getColumns_chargeMonth,
}

function getColumns() {
    return [
        getColumns_debitNoteId(),
        getColumns_comId(),
        getColumns_accountCode(),
        getColumns_productCode(), 
        getColumns_planNum(), 
        getColumns_bindKey(), 
        getColumns_bindValue(), 
        getColumns_SqlAccountInvoiceNo(),
        getColumns_productName(),
        getColumns_dealerCode(),
        getColumns_salesPersonCode(),
        getColumns_chargeMethod(),
        getColumns_chargeMonth(),
        getColumns_unitPrice(),
        getColumns_quantity(),
        getColumns_subtotal(),
        getColumns_subsidiary(),
        getColumns_debitNoteRemark(),
    ];
}

function getColumns_debitNoteId() {
    let columnClassName = "table__debit-note-id";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Debit Note ID",
        id: "debitNoteId",
        accessor: "Id",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_comId() {
    let columnClassName = "table__com-id";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Com ID",
        id: "comId",
        accessor: "CompanyId",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_accountCode() {
    let columnClassName = "table__account-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Account Code",
        id: "accountCode",
        accessor: "AccountCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_productCode() {
    let columnClassName = "table__product-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Product Code",
        id: "productCode",
        accessor: "ProductCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_SqlAccountInvoiceNo() {
    let columnClassName = "advancePayInvoices-tableColumn-sqlAccountInvoiceNo";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Reference Document No.",
        id: "sqlAccountInvoiceNo",
        accessor: "ReferenceDocumentNo",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 300
    }
}

function getColumns_productName() {
    let columnClassName = "table__product-name";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Product Name",
        id: "productName",
        accessor: "ProductName",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_dealerCode() {
    let columnClassName = "table__dealer-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Dealer Code",
        id: "dealerCode",
        accessor: "DealerCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_salesPersonCode() {
    let columnClassName = "table__sales-person-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Sales Person Code",
        id: "salesPersonCode",
        accessor: "SalesPersonCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_debitNoteRemark() {
    let columnClassName = "table__debit-note-remark";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Debit Note Remark",
        id: "debitNoteRemark",
        accessor: "DebitNoteRemark",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <Tooltip
                    targetClassName={"debit-note-remark__content noWrap-text-ellipsis"}
                    target={value_formatted}
                    tooltipContent={value_formatted}
                />
            );
        },
        width: 300
    }
}

function getColumns_chargeMethod() {
    let columnClassName = "table__charge-method";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Charge Method",
        id: "chargeMethod",
        accessor: "ChargeMethod",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_quantity() {
    let columnClassName = "table__quantity justify-content-center";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Quantity",
        id: "quantity",
        accessor: "Quantity",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_unitPrice() {
    let columnClassName = "table__unit-price";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "Unit Price (RM)",
        id: "unitPrice",
        accessor: "UnitPrice",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";
            if (value_formatted != "-")
                value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_subtotal() {
    let columnClassName = "table__subtotal";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "Subtotal (RM)",
        id: "subtotal",
        accessor: "SubTotal",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";
            if (value_formatted != "-")
                value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_chargeMonth() {
    let columnClassName = "table__charge-month";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Charge Month",
        id: "chargeMonth",
        accessor: "ChargeMonth",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_planNum() {
    let columnClassName = "table__plan-No";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Plan No",
        id: "PlanNo",
        accessor: "PlanNo",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_bindKey() {
    let columnClassName = "table__bind-key";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Bind Key",
        id: "bindKey",
        accessor: "BindKey",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_bindValue() {
    let columnClassName = "table__bind-value";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Bind Value",
        id: "bindValue",
        accessor: "BindValue",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_subsidiary() {
    let columnClassName = "table__debit-note-subsidiary";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Subsidiary",
        id: "subsidiary",
        accessor: "Subsidiary",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)
            ? value
            : "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    };
}